import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { sampleBlogs } from './blogs';
import '../../styles/blogs.css';
import Navbar from '../common/Navbar';

export default function BlogContent({ blog: blogProp }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const blog = blogProp || sampleBlogs.find((b) => b.slug === slug);

  if (!blog) {
    return (
      <div className="blog-not-found blog-fade-in">
        <div className="blog-not-found-inner text-center">
          <div className="blog-not-found-code ff_s">
            404
          </div>
          <div className="blog-not-found-content">
            <h1 className="ff_s">This page doesn't exist</h1>
            <p className="ff_n">
              The post you're looking for may have been moved, renamed, or removed.
            </p>
            <button
              onClick={() => navigate('/blogs')}
              className="blog-back-btn ff_n"
            >
              ← Back to All Articles
            </button>
          </div>
        </div>
      </div>
    );
  }

  const formattedDate = blog.createdAt ? new Date(blog.createdAt).toLocaleDateString() : 'Undated';
  const readMins = blog.readTime || 5;
  const hasImage = blog.featuredImage && !imageError;

  return (
    <>
      <div className="blog-progress-bar" />
      <Navbar/>
      <article className="blog-detail-page">
        <header className={` blog-detail-hero ${hasImage ? '' : 'blog-detail-hero-empty'}`}>
            
          {hasImage && (
             <img
              src={blog.featuredImage}
              alt={blog.title}
              className="blog-detail-hero-image blog-fade-in"
              onError={() => setImageError(true)}
            />
          )}
          
          <div className="blog-detail-hero-overlay" />

          <div className="container blog-detail-hero-layer">
            <button
              onClick={() => navigate('/blogs')}
              className="blog-detail-back ff_n"
            >
              ← All Articles
            </button>

            <div className="blog-detail-hero-content blog-fade-up">
              <div className="blog-detail-meta ff_n">
                <time>{formattedDate}</time>
                <span />
                <span>{readMins} min read</span>
              </div>

              <h1 className="blog-detail-title ff_s">
                {blog.title}
              </h1>
            </div>
          </div>
        </header>

        <main className="container blog-detail-body blog-fade-up" style={{ animationDelay: '0.2s' }}>
          <div
            className="hki-blog-content"
            dangerouslySetInnerHTML={{ __html: blog.content || '<p>No content available.</p>' }}
          />

          <div className="blog-detail-separator">
            <div />
            <span />
            <div />
          </div>

          <footer className="blog-detail-footer">
            <div>
              <p className="blog-detail-footer-title ff_s">Enjoyed this article?</p>
              <p className="blog-detail-footer-text ff_n">Explore more insights and trends from HKI Media.</p>
            </div>
            <button
              onClick={() => navigate('/blogs')}
              className="blog-back-btn ff_n"
            >
              Browse All Articles →
            </button>
          </footer>
        </main>
      </article>
    </>
  );
}